import axiosInstance from "./AxiosInstance";
import config from "../config";

export const fetchAllUsers = (page, size) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.users,
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      page: page,
      size: size,
    },
  });
};
export const fetchProfileCompleteNumber = () => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.profileComplete,
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const addUserProfile = (data, cond) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: cond ? config.routes.user : config.routes.userId(data.id),
    method: cond ? "post" : "put",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      address: data?.address,
      city: data?.city,
      confirmpassword: data?.confirmPwd,
      country: data?.country,
      email: data?.email,
      firstname: data?.firstname,
      idrole: parseInt(data?.idRole),
      lastname: data?.lastname,
      password: data?.password,
      phone: data?.phone,
      // photo: data?.base64,
      username: data?.username,
      profession: data?.profession,
      otherinterests: data?.otherinterests,
      subinterests: data?.subinterests,
    },
  });
};

export const changeUserStatus = (id, status) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.userStatus(id, status ? "disable" : "enable"),
    method: "put",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteUser = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.userId(id),
    method: "delete",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const changePwdService = (id, data) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.changePwd(id),
    method: "put",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      newpassword: data?.newPwd,
      oldpassword: data?.oldPwd,
    },
  });
};
export const changeTemPwdService = (data) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.changeTemPwd,
    method: "put",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      password: data?.password,
      confirmpassword: data?.confirmpassword,
    },
  });
};

export const resetPwd = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.resetPwd(id),
    method: "put",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const fetchUserDetails = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.userId(id),
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const updateUser = (id, data) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.userId(id),
    method: "put",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: data,
  });
};
